import { render } from "./InvitationDialog.vue?vue&type=template&id=2cf85935&scoped=true"
import script from "./InvitationDialog.vue?vue&type=script&lang=js"
export * from "./InvitationDialog.vue?vue&type=script&lang=js"

import "./InvitationDialog.vue?vue&type=style&index=0&id=2cf85935&scoped=true&lang=css"

import exportComponent from "D:\\project2025\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf85935"]])

export default __exports__